import React from 'react';
import { useParams, Link } from 'react-router-dom';
import DefaultLayout from '../../../../layouts/default';
import Loader from '../../../../components/Loader';
import OpeningCheckForm from './components/OpeningCheckForm';
import OpeningCheckHeader from './components/OpeningCheckHeader';
import CheckProgressWidget from './components/CheckProgressWidget';
import ComplianceRecordsSummary from './components/ComplianceRecordsSummary';
import { DeliveryDetailProvider, useDeliveryDetail } from './context/DeliveryDetailContext';
function DeliveryContent() {
  const { loading, error, reload } = useDeliveryDetail();
  if (loading) return <Loader message="Loading delivery check..." className="py-16" />;
  if (error) return <div role="alert" className="py-10 text-sm text-red-600">{error} <button onClick={reload} className="underline">Retry</button> <Link to="/checks/delivery-check" className="text-indigo-600 underline">Back to deliveries</Link></div>;
  return <><OpeningCheckHeader /><div className="grid grid-cols-1 gap-4 lg:grid-cols-12"><div className="lg:col-span-9"><OpeningCheckForm /></div><aside className="lg:col-span-3"><CheckProgressWidget /><ComplianceRecordsSummary /></aside></div></>;
}
export default function DeliveryCheckDetailPage() {
  const { id } = useParams();
  if (!/^\d+$/.test(id || '') || Number(id) <= 0) return <DefaultLayout><p role="alert">Invalid delivery ID.</p><Link to="/checks/delivery-check">Back to deliveries</Link></DefaultLayout>;
  return <DefaultLayout><DeliveryDetailProvider key={id} id={Number(id)}><DeliveryContent /></DeliveryDetailProvider></DefaultLayout>;
}
